'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _extends = require('../../node_modules/@babel/runtime/helpers/esm/extends.js');

var objectWithoutProperties = require('../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js');

var React = require('react');

var index = require('../../node_modules/prop-types/index.js');

var index$1 = require('../../node_modules/classnames/index.js');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

var _excluded = ["border", "brand", "className", "fab", "duotone", "fal", "fad", "far", "solid", "fixed", "fas", "flip", "icon", "inverse", "light", "list", "pull", "pulse", "regular", "rotate", "size", "spin", "stack"];

var Icon = function Icon(props) {
  var border = props.border,
      brand = props.brand,
      className = props.className,
      fab = props.fab,
      duotone = props.duotone,
      fal = props.fal,
      fad = props.fad,
      far = props.far,
      solid = props.solid,
      fixed = props.fixed,
      fas = props.fas,
      flip = props.flip,
      icon = props.icon,
      inverse = props.inverse,
      light = props.light,
      list = props.list,
      pull = props.pull,
      pulse = props.pulse,
      regular = props.regular,
      rotate = props.rotate,
      size = props.size,
      spin = props.spin,
      stack = props.stack,
      attributes = objectWithoutProperties['default'](props, _excluded);
  var iconPrefix = regular || far ? 'far' : solid || fas ? 'fas' : light || fal ? 'fal' : duotone || fad ? 'fad' : brand || fab ? 'fab' : 'fa';
  var classes = index$1['default'](iconPrefix, list ? 'fa-li' : false, icon ? "fa-".concat(icon) : false, size ? "fa-".concat(size) : false, fixed ? 'fa-fw' : false, pull ? "fa-pull-".concat(pull) : false, border ? 'fa-border' : false, spin ? 'fa-spin' : false, pulse ? 'fa-pulse' : false, rotate ? "fa-rotate-".concat(rotate) : false, flip ? "fa-flip-".concat(flip) : false, inverse ? 'fa-inverse' : false, stack ? "fa-".concat(stack) : false, className);
  return /*#__PURE__*/React__default['default'].createElement("i", _extends['default']({
    "data-test": "fa"
  }, attributes, {
    className: classes
  }));
};

Icon.propTypes = {
  icon: index['default'].string.isRequired,
  border: index['default'].bool,
  brand: index['default'].bool,
  className: index['default'].string,
  duotone: index['default'].bool,
  fab: index['default'].bool,
  fad: index['default'].bool,
  fal: index['default'].bool,
  far: index['default'].bool,
  fas: index['default'].bool,
  fixed: index['default'].bool,
  flip: index['default'].string,
  inverse: index['default'].bool,
  light: index['default'].bool,
  list: index['default'].bool,
  pull: index['default'].string,
  pulse: index['default'].bool,
  regular: index['default'].bool,
  rotate: index['default'].string,
  size: index['default'].string,
  solid: index['default'].bool,
  spin: index['default'].bool,
  stack: index['default'].string
};
Icon.defaultProps = {
  border: false,
  brand: false,
  className: '',
  fab: false,
  fal: false,
  far: false,
  fixed: false,
  flip: '',
  inverse: false,
  light: false,
  list: false,
  pull: '',
  pulse: false,
  regular: false,
  rotate: '',
  size: '',
  spin: false,
  stack: '',
  duotone: false,
  fad: false,
  solid: false,
  fas: false
};
exports.Icon = Icon;
exports['default'] = Icon;